import { useState, useEffect, useRef } from 'react'
import View from '@modul-connect/shared/components/atoms/view'
import TextField from '@modul-connect/shared/components/molecules/textField'
import { P } from '../../atoms/text'
import theme from '../../../theme'
import InfoLabel from '@modul-connect/shared/components/molecules/infoLabel/infoLabel'

const RangeInput = ({
  label,
  required,
  showInfoIcon,
  fromValue,
  toValue,
  onChangeFrom,
  onChangeTo,
  showInfoText,
  infoText,
  hasErrorFromValue,
  hasErrorToValue,
  errorText,
  inlineText,
  type,
  step
}) => {
  const [isInfoOpen, setIsInfoOpen] = useState(false)
  const infoWrapperRef = useRef(null) 

  const S = styles

  useEffect(() => {
    if (!isInfoOpen) return

    const handleClickOutside = event => {
      if (
        infoWrapperRef.current &&
        !infoWrapperRef.current.contains(event.target)
      ) {
        setIsInfoOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isInfoOpen])

  return (
    <View extend={S.wrapper}>
      <InfoLabel
        label={label}
        required={required}
        showInfoIcon={showInfoIcon}
        showInfoText={showInfoText}
        infoText={infoText}
      />

      <View extend={S.range_row}>
        <View extend={S.range_column}>
          <TextField
            type={type}
            step={step}
            extend={S.range_input}
            value={fromValue}
            inlineText={inlineText}
            onChange={e => onChangeFrom(e.target.value)}
          />
          <View extend={{opacity: hasErrorFromValue ? 1 : 0}}>
            <P small noPadding extend={S.errorText}>{errorText}</P>
          </View>
        </View>

        <P color={theme.colors.errorText} style={S.to_label}>
          TO
        </P>
        <View extend={S.range_column}>
          <TextField
            type={type}
            step={step}
            extend={S.range_input}
            inlineText={inlineText}
            value={toValue}
            onChange={e => onChangeTo(e.target.value)}
          />
          <View extend={{opacity: hasErrorToValue ? 1 : 0}}>
            <P small noPadding extend={S.errorText}>{errorText}</P>
          </View>
        </View>
      </View>
    </View>
  )
}

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },

  label_row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8
  },

  label_text: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: 12,
    lineHeight: '15px',
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
  },

  required_mark: {
    color: '#D32F2F',
    marginLeft: 2,
  },

  info_icon_wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    cursor: 'pointer',
  },

  info_icon: {
    width: 11,
    height: 11,
    borderRadius: '50%',
  },

  range_row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },

  range_input: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 16,
    width: '100%',
    height: 27,
    border: '1px solid #CACACA',
    backgroundColor: 'transparent',
    borderRadius: 4,
    marginBottom: 0,
  },

  input: {
    width: 40,
    border: 'none',
    outline: 'none',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: 16,
    lineHeight: '19px',
    color: '#646464',
    textAlign: 'right',
    background: 'transparent',
  },

  unit: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: 16,
    lineHeight: '19px',
    color: '#646464',
  },

  to_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 18,
    height: 27,
  },

  to_label: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 12,
    lineHeight: '15px',
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    color: '#606060',
    alignSelf: 'flex-start',
    marginTop: 7
  },

  info_text_box: {
    display: 'flex',
    alignItems: 'flex-start',
    position: 'absolute',
    minWidth: '200px',
    maxWidth: '360px',
    borderRadius: 8,
    top: -7,
    left: -7,
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: 12,
    lineHeight: '16px',
    color: '#141414',
    backgroundColor: theme.colors.white,
    zIndex: 1000,
    padding: '8px',
    gap: 8,
    whiteSpace: 'normal',
    wordWrap: 'break-word',
  },
  errorText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: 12,
    color: theme.colors.error
  },
  range_column: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  }
}

export default RangeInput